
  
//find out what they are using  
var userAgent = window.navigator.userAgent.toLowerCase();
window.facebook = /fb/.test( userAgent );
window.instagram = /instagram/.test( userAgent );
window.samsung = /samsungbrowser/.test( userAgent );
window.iphone = /iphone/.test( userAgent );
window.android = /android/.test( userAgent );
window.ie = /edge|msie|trident/.test(userAgent);


  
if(window.iphone || window.android || window.samsung || window.instagram || window.facebook) {
 window.mobile = 'mobile';   
}




jQuery(document).on('mobileinit',function(){
  $.event.special.swipe.horizontalDistanceThreshold = 80;
//$.mobile.loadingMessage = false;
    $.mobile.defaultHomeScroll = 0;
    $.mobile.hoverDelay = 50;

  $.mobile.loader.prototype.options.html = "<div class='sk-three-bounce'><div class='sk-child sk-bounce1'></div><div class='sk-child sk-bounce2'></div><div class='sk-child sk-bounce3'></div></div>";
$(function(){ 
	$( "#header" ).toolbar();
  if(window.ie != true) {
   $( "#footer" ).toolbar();
  }
    $("#mobilemenu").enhanceWithin().panel();
  //disable page transition
  if($(window).width() > 1024) {
    $.mobile.defaultPageTransition = 'fade';
  }else{
      $.mobile.defaultPageTransition = 'fade';
  }
      $.mobile.useFastClick = true;
      $.mobile.page.prototype.options.domCache = true;

      
});
  
});

  
// if coming soon 
/*
$(document).one("pageshow", ".ui-page", function(event) {  
    window.loaded = true; 
  jQuery('body').addClass('loaded');
  setTimeout(function() {
 jQuery('#welcome-loader').remove();
  },2000);
  
});
*/